import { Location } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-page-not-found',
  templateUrl: './page-not-found.component.html',
  styleUrls: ['./page-not-found.component.scss']
})
export class PageNotFoundComponent {

  constructor(private location: Location) {}

  /**
   * Regresa a la última URL visitada.
   */
  backClicked() {
    this.location.back();
  }

}
